import type { LucideIcon } from "lucide-react";

interface Props {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

/**
 * Унифицированное пустое состояние под стиль макета:
 * - кремовый фон с тонкой dashed-обводкой
 * - иконка Lucide в круге brand/10
 * - заголовок + опциональное описание
 * - опциональная кнопка действия
 */
export function EmptyState({ icon: Icon, title, description, action }: Props) {
  return (
    <div className="card border-dashed bg-surface-alt p-10 text-center">
      {Icon && (
        <div className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-full bg-brand/10 text-brand">
          <Icon size={22} strokeWidth={1.8} />
        </div>
      )}
      <h3 className="text-base font-semibold text-ink">{title}</h3>
      {description && (
        <p className="mx-auto mt-1 max-w-md text-sm text-ink-muted">{description}</p>
      )}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}
